import { Box, Button, Typography } from '@mui/material';
import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SummaryItem } from '~/components/MyWorkspace/SummaryItem';
import { SanitizeHTML } from '~/components/SanitizeHTML';
import { People } from '~/services/Http';

import { useAnnouncement } from './useAnnouncement';
import { useSxStyles } from './useStyles';

export interface Props {
  announcement: People.CompanyPostDto;
  onReadMoreClick?: (id: number) => void;
}

export const Announcement: React.FC<Props> = (props) => {
  const { announcement } = props;
  const ref = React.createRef<HTMLDivElement>();
  const { hasOverflow, handleReadMoreClick } = useAnnouncement(ref, props);
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  return (
    <Box
      sx={{
        ...sxStyles.root,
        ...(hasOverflow ? sxStyles.rootBefore : {}),
      }}
      ref={ref}
      data-cy={`announcement:${announcement.id}`}
    >
      <SummaryItem
        avatarProps={{
          alt: announcement.updatedBy?.firstName,
          src: announcement.updatedBy?.profilePic,
        }}
        listItemProps={{ disableGutters: true }}
        primaryElement={announcement.title}
        secondaryElement={`${t('updated').toUpperCase()} ${moment(
          announcement.updatedAt,
        ).format('L LT')}`}
      />
      <Typography component="div" variant="body2" sx={sxStyles.message}>
        <SanitizeHTML html={announcement.content} />
      </Typography>
      <Button
        color="primary"
        size="small"
        sx={{
          ...sxStyles.readMoreButton,
          ...(hasOverflow ? {} : sxStyles.hidden),
        }}
        onClick={handleReadMoreClick}
        data-cy="read-more"
      >
        {t('readMore')}
      </Button>
    </Box>
  );
};
